<template>
  <div class="options-group"
       :class="{'options-group--expanded': group.expanded}"
       :key="group[groupValueKey]"
  >
    <!-- Group head -->
    <div class="options-group__head">
      <i class="arrow"
         :class="{
            'icon-chevron-down': group.expanded,
            'icon-chevron-right': !group.expanded
          }"
         @click="emit('groupToggle', group)"
      />

      <FormCheckbox
          v-if="multiple"
          v-model="group.selected"
          label-disabled
          :items="group.items"
          @check="emit('selectGroup', group)"
          @deselect="emit('selectGroup', group)"
      />

      <span class="title"
            @click="emit('groupToggle', group)"
      >
          {{ group[groupTitleKey]}}

          <span v-if="group?.items_count" class="options-group__count">
            {{ group.items_count }}
          </span>
      </span>
    </div>

    <!-- Group content -->
    <Collapsable
        v-model:expanded="group.expanded"
    >
      <div class="options-group__content">
        <SelectOption
            v-for="option in options"
            :key="option[valueKey]"
            :option="option"
            v-bind="optionProps"
            @select="emit('select', option)"
        >
          <slot name="option"
                v-bind="{option}"
          />
        </SelectOption>
      </div>
    </Collapsable>
  </div>
</template>
<script setup>
import FormCheckbox from "@/js/Elements/Form/FormCheckbox.vue";
import SelectOption from "@/js/Elements/Select/SelectOption.vue";
import Collapsable from "@/js/Elements/Collapsable.vue";
import {computed} from "vue";

const emit = defineEmits(['select', 'selectGroup', 'groupToggle']);
const props = defineProps({
  group: Object,
  valueKey: String,
  groupTitleKey: String,
  groupValueKey: [String],
  optionProps: Object,
  grid: [String, Number],
  multiple: Boolean,
});

const options = computed(() => props.group.items.filter(option => option._visible_));
</script>
<style lang="scss" scoped>
@import "@/css/functions";
@import "@/css/variables";

.options-group__head {
  display: flex;
  align-items: center;
  padding: spacing(2);
  gap: spacing(2);
  font-weight: $font-weight-medium;
  padding-left: spacing(4);
  border-bottom: themeColor('border') solid toRem(1);

  .arrow {
    color: themeColor('neutral-700');
    font-size: toRem(10);
    margin-top: toRem(2);
  }
  .title { width: 100%; }

  .arrow,
  .title {
    cursor: pointer;
  }
}

.options-group__count {
  color: themeColor('neutral-500');
}

.options-group:not(.options-group--expanded) .options-group__head {
  border-bottom: none;
}

.options-group__content {
  display: flex;
  flex-direction: column;
  padding: spacing(2);
  padding-right: 0;
  gap: spacing(2);

  &:deep(.option__content) {
    //border: themeColor('border') solid toRem(1);
    border-radius: $border-radius-lg;
  }
}
</style>